import { useState, useEffect, useCallback } from 'preact/hooks';
import '../styles/videotab.css';

const API_KEY = 'AIzaSyBzWrc5pzV9SvPsNaal6TRiIZ8dqK96dYA';
const CHANNEL_ID = 'UCYx85_qIDrJuvQ_Wm6WCDPQ';
const MAX_RESULTS = 6;

const VideoTab = () => {
  const [videos, setVideos] = useState([]);
  const [nextPageToken, setNextPageToken] = useState(null);
  const [loading, setLoading] = useState(false);
  const [playlistId, setPlaylistId] = useState('');

  // Получаем ID плейлиста загрузок
  useEffect(() => {
    const fetchUploadsPlaylistId = async () => {
      try {
        const res = await fetch(
          `https://www.googleapis.com/youtube/v3/channels?part=contentDetails&id=${CHANNEL_ID}&key=${API_KEY}`
        );
        const data = await res.json();
        const uploadId = data.items?.[0]?.contentDetails?.relatedPlaylists?.uploads;
        if (uploadId) setPlaylistId(uploadId);
      } catch (err) {
        console.error('Ошибка при получении upload playlist ID:', err);
      }
    };

    fetchUploadsPlaylistId();
  }, []);

  // Загрузка видео по токену
  const fetchVideos = useCallback(async (pageToken = '') => {
    if (!playlistId) return;
    try {
      setLoading(true);
      const res = await fetch(
        `https://www.googleapis.com/youtube/v3/playlistItems?part=snippet&maxResults=${MAX_RESULTS}&playlistId=${playlistId}&key=${API_KEY}&pageToken=${pageToken}`
      );
      const data = await res.json();

      const newVideos = data.items?.map(item => ({
        id: item.snippet.resourceId.videoId,
        title: item.snippet.title,
        thumbnail: item.snippet.thumbnails.medium.url,
      })) || [];

      setVideos(prev => [...prev, ...newVideos]);
      setNextPageToken(data.nextPageToken || null);
    } catch (err) {
      console.error('Ошибка при загрузке видео:', err);
    } finally {
      setLoading(false);
    }
  }, [playlistId]);

  // Загружаем видео при получении playlistId
  useEffect(() => {
    if (playlistId) {
      fetchVideos();
    }
  }, [playlistId, fetchVideos]);

  // Открытие всплывающего окна с видео
  const openVideoPopup = (videoId) => {
    const existingPopup = document.querySelector('.video-popup-overlay');
    if (existingPopup) existingPopup.remove();

    const overlay = document.createElement('div');
    overlay.className = 'video-popup-overlay';

    overlay.innerHTML = `
      <div class="video-popup">
        <iframe src="https://www.youtube.com/embed/${videoId}?autoplay=0"
                frameborder="0"
                allow="autoplay; encrypted-media"
                allowfullscreen>
        </iframe>
        <button class="close-popup">×</button>
      </div>
    `;

    overlay.querySelector('.close-popup').onclick = () => overlay.remove();
    document.body.appendChild(overlay);
  };

  return (
    <div className="video-tab">
      <h2>Видео</h2>
      <div className="video-grid">
        {videos.map(video => (
          <div className="video-item" key={video.id}>
            <img
              src={video.thumbnail}
              alt={video.title}
              onClick={() => openVideoPopup(video.id)}
            />
            <p>{video.title}</p>
          </div>
        ))}
      </div>
      {nextPageToken && (
        <button
          className="load-more-btn"
          onClick={() => fetchVideos(nextPageToken)}
          disabled={loading}
        >
          {loading ? 'Загрузка...' : 'Больше'}
        </button>
      )}
    </div>
  );
};

export default VideoTab;
